import React from 'react';
import _get from 'lodash/get';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import Image from '@lib/components/Image/Image';
import getSsoProviderIcon from '@lib/utils/sso/getSsoProviderIcon';
import getSsoProviderDisplayName from '@lib/utils/sso/getSsoProviderDisplayName';
import { SsoIntegrationPreviewData } from 'utils/sso';
import styles from './SsoProviderButton.module.scss';

interface SsoProviderButtonProps {
  integration: SsoIntegrationPreviewData;
  onClick: (code: string) => void;
}

function SsoProviderButton({ integration, onClick }: SsoProviderButtonProps) {
  const { code, name, providerPreset, icon } = integration;

  const customIconUrl = _get(icon, 'urls.small') || _get(icon, 'urls.original');
  const iconSrc = customIconUrl || getSsoProviderIcon(providerPreset);
  const displayName = name || getSsoProviderDisplayName(providerPreset);

  return (
    <Button
      buttonType={ButtonTypes.secondaryOutlined}
      buttonText={displayName}
      fullWidth
      showTooltipOnCrop
      onClick={() => onClick(code)}
      leftContent={
        <Image src={iconSrc} alt={displayName} className={styles.icon} />
      }
      leftContentClassName={styles.iconWrap}
    />
  );
}

export default SsoProviderButton;
